import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getDetail } from '../../store/features/SPAJSlice'
import { Row, Col } from 'react-bootstrap';
import styles from './landing.module.css'
import "./landing.module.css"
import Spinners from '../../component/Spinner/spinners';
import Header from '../../component/Header/header';
import ProgressBar from '../../component/ProgressBar/progressbar';
import { StatusCustomer, logoutClose, logoutWhenIdle } from '../../component/Helper'
import { getIllustrationSPAJ } from '../../store/features/IllustrationSPAJSlice'
import { getIlustrationSignature, getSelfie } from '../../store/features/CameraAndSignatureSlice'


export default function LandingPage() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    let [loading, setLoading] = useState(false)
    const { DeviceId } = useSelector((state) => state.DeviceId)
    // const { SPAJDetail } = useSelector((state) => state.SPAJsDetail)
    const [spajDetail, setSpajDetail] = useState({});
    const SPAJs = useSelector(state => state.SPAJs.SPAJs)
    const [statusCustomer, setStatusCustomer] = useState("");
    const [isUnitLink, setIsUnitLink] = useState(0);
    const { Parameter } = useSelector((state) => state.Params);
    // const userAgent = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
    useEffect(() => {
        logoutClose(DeviceId.deviceId)
        logoutWhenIdle(Parameter.dataParameterApps, DeviceId.deviceId);
        setLoading(true)
        setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink));
        setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
        let detailData = {
            deviceId: `${DeviceId.deviceId}`,
            userName: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`
        }
        dispatch(getDetail(detailData)).then(res => {
            setLoading(false)
            setSpajDetail(res.payload.data)
        }).catch(err => {
            setLoading(false)
            setLoadingSPAJ(false);
        })
    }, [])

    useEffect(() => {

        let data = {
            deviceId: `${DeviceId.deviceId}`,
            userName: `${spajDetail?.dataSpaj?.email}`,
            spajNumber: `${spajDetail?.dataSpaj?.spajNumber}`,
            // apps: "sys"
        }
        if(spajDetail?.dataSpaj?.spajNumber !== undefined)
        {
            setLoading(true)

            dispatch(getIlustrationSignature(data)).then(res => {
                dispatch(getSelfie(data)).then(res => {
                    dispatch(getIllustrationSPAJ(data)).then(res => {
                        setLoading(false)
                    }).catch(err => {
                        setLoading(false)
                    })
                }).catch(err => {
                    setLoading(false);
                })
            }).catch(err => {
                setLoading(false);
            })
        }
    }, [spajDetail])

    const navigatePage = () => {
        console.log("statusCustomer",statusCustomer)
        if (statusCustomer == 1) {
            navigate('/ilustrasi');
        } else if (statusCustomer == 2) {
            navigate('/spaj-detail');
        } else if (statusCustomer == 3) {
            navigate('/form-final-step');
        } else if (statusCustomer == 4) {
            navigate('/persetujuan');
        } else if (statusCustomer == 5) {
            navigate('/pembayaran');
        } else if (statusCustomer == 6) {
            navigate('/final-step');
        } else if (statusCustomer == 7) {
            navigate('/pembayaranul');
        } else if (statusCustomer == 8) {
            navigate('/dokumen-susulan');
        } else {
            navigate('/ilustrasi');
        }
    }

    // if (loading == true) {
    //     return (
    //         <Spinners />
    //     )
    // }
    return (
        <>
            {loading == true && <Spinners />}
            <div>
                <Header />
                <div style={{position:'absolute',width:'100%',zIndex:998}}>
                    <ProgressBar step="1" status={statusCustomer} isUnitlink={isUnitLink}/>
                </div>
                <Row className="g-0 welcome-container">
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className={`position-relative ${styles.leftContainer} `}>
                            <div className={`${styles.cardContainer} ${styles.cardContainer2}`}>
                                <div className='bold fs-16 text-center'>Selamat Datang!</div>
                                <div className='mt-2'>
                                    <div className='bold text-red fs-16 text-center'>{spajDetail?.dataSpaj?.fullName}</div>
                                    {/* <div className='bold text-red fs-16 text-center'>SPAJ {SPAJDetail.dataSpaj?.spajNumber}</div> */}
                                </div>
                                <div className='mt-2'>
                                    <div className='fs-12 text-center'>Silakan melanjutkan proses Pengajuan Asuransi Jiwa Anda nomor {spajDetail?.dataSpaj?.spajNumber} sesuai dengan tahapan di atas dengan klik tombol "Mulai"</div>
                                </div>
                                <div className='mt-2'>
                                    <button className='button-red' onClick={() => navigatePage()}>Mulai</button>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className='posisi-image'>
                            <img src="images/landing-page.jpg" className="ilustration imageLanding" style={{marginTop:'140px'}} />
                        </div>
                    </Col >
                </Row >
            </div >
        </>
    )
}